import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import Select, { selectClasses } from "@mui/joy/Select";
import Option from "@mui/joy/Option";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Grids from "../../components/grids";
import AddCustomer from "../../components/modals/addcustomer";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AuthContext from "../../contexts/authContext";
import axiosInstance from "../../api/axios";
import toast from "react-hot-toast";
import Payments from "../../components/modals/payments";
import ViewCustomer from "../../components/modals/viewCustomer";
import AddIcon from "@mui/icons-material/Add";
import AddCustScheme from "../../components/modals/addcustScheme";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Modal } from "@mui/joy";

const Customers = () => {
  const { userData, setRefresh } = useContext(AuthContext);
  const [openAddCust, setOpenAddCust] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [editId, setEditId] = useState("");
  const [openViewCustomer, setOpenViewCustomer] = useState(false);
  const [scheme, setScheme] = useState("All");
  const [paymentFilter, setPaymentFilter] = useState("All");
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [openAddScheme, setOpenAddScheme] = useState(false);
  const role = localStorage.getItem("role");
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [updateText, setUpdateText] = useState("");

  const columns = [
    {
      field: "id",
      headerName: "S.No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 80,
      flex: 1,
    },
    {
      field: "name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "left",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "mobile",
      headerName: "Mobile",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "address",
      headerName: "Address",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "left",
      minWidth: 180,
      flex: 2,
    },
    {
      field: "area",
      headerName: "Area",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "left",
      minWidth: 180,
      flex: 2,
    },
    {
      field: "agent",
      headerName: "Agent",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      flex: 1,
    },

    {
      field: "scheme",
      headerName: "Scheme",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      flex: 1,
    },
    // {
    //   field: "payments",
    //   headerName: "Payments",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   align: "center",
    //   minWidth: 120,
    //   flex: 1,
    // },

    {
      field: "status",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {params.row.status === "active" ? (
            <Typography
              sx={{
                color: "#fff",
                backgroundColor: "darkgreen",
                // padding: "2px 10px",
                width: "100%",
                borderRadius: "5px",
              }}
            >
              {params.row.status}
            </Typography>
          ) : (
            <Typography
              sx={{
                color: "#fff",
                backgroundColor: "#800001",
                // padding: "2px 10px",
                width: "100%",
                borderRadius: "5px",
              }}
            >
              {params.row.status}
            </Typography>
          )}
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      flex: 2,
      minWidth: 80,
      maxWidth: 100,

      // renderCell: (params) => (
      //   <Box
      //     sx={{
      //       display: "flex",
      //       justifyContent: "center",
      //       alignItems: "center",
      //       height: "100%",
      //     }}
      //   >
      //     <IconButton
      //       sx={{
      //         color: "#800001",
      //         "&:hover": {
      //           backgroundColor: "#800001",
      //           color: "#fff",
      //         },
      //       }}
      //       onClick={() => handleviewCustomer(params.row._id)}
      //     >
      //       <Icon>
      //         <VisibilityIcon />
      //       </Icon>
      //     </IconButton>

      //     {role === "admin" && (
      //       <IconButton
      //         sx={{
      //           color: "#800001",
      //           "&:hover": {
      //             backgroundColor: "#800001",
      //             color: "#fff",
      //           },
      //         }}
      //         onClick={() => handleEditCustomer(params.row._id)}
      //       >
      //         <Icon>
      //           <EditIcon />
      //         </Icon>
      //       </IconButton>
      //     )}
      //     <IconButton
      //       sx={{
      //         color: "#800001",
      //         "&:hover": {
      //           backgroundColor: "#800001",
      //           color: "#fff",
      //         },
      //       }}
      //       onClick={() => handleAddScheme(params.row._id)}
      //     >
      //       <Icon>
      //         <AddIcon sx={{ fontWeight: "bold" }} fontSize="medium" />
      //       </Icon>
      //     </IconButton>

      //     <IconButton
      //       sx={{
      //         color: "#800001",
      //         "&:hover": {
      //           backgroundColor: "#800001",
      //           color: "#fff",
      //         },
      //       }}
      //       onClick={() => handleCustomerPayment(params.row._id)}
      //     >
      //       <Icon>
      //         <CurrencyRupeeIcon />
      //       </Icon>
      //     </IconButton>

      //     {role === "admin" && (
      //       <IconButton
      //         sx={{
      //           color: "#800001",
      //           "&:hover": {
      //             backgroundColor: "#800001",
      //             color: "#fff",
      //           },
      //         }}
      //         onClick={() => handleDeleteCustomer(params.row._id)}
      //       >
      //         <Icon>
      //           <DeleteIcon />
      //         </Icon>
      //       </IconButton>
      //     )}
      //   </Box>
      // ),
      renderCell: (params) => (
        <IconButton
          onClick={(e) => handleOpenMenu(e, params.row._id)}
          sx={{ color: "#800001" }}
        >
          <MoreVertIcon />
        </IconButton>
      ),
    },
  ];
  const handleAddUpdate = (id) => {
    setCustomerId(id);
    setUpdateText("");
    setOpenUpdateModal(true);
  };

  useEffect(() => {
    let totalCustomers = userData?.customers?.filter(
      (cus) => cus.status === "active"
    );

    if (!totalCustomers) return;

    // Scheme filter
    if (scheme !== "All") {
      totalCustomers = totalCustomers.filter((cus) =>
        cus.scheme?.some((s) => s.schemeId === scheme)
      );
    }

    // Payment filter
    if (paymentFilter === "paid") {
      totalCustomers = totalCustomers.filter(
        (cus) => cus.scheme?.[0]?.amount > 0
      );
    } else if (paymentFilter === "unpaid") {
      totalCustomers = totalCustomers.filter(
        (cus) => cus.scheme?.[0]?.amount === 0
      );
    } else if (paymentFilter === "active") {
      totalCustomers = totalCustomers.filter((cus) => {
        const activeCount =
          cus?.scheme?.filter((s) => s.status === "active").length || 0;
        return activeCount > 0;
      });
    } else if (paymentFilter === "inactive") {
      totalCustomers = totalCustomers.filter((cus) => {
        const activeCount =
          cus?.scheme?.filter((s) => s.status === "active").length || 0;
        return activeCount === 0;
      });
    }

    // Search filter
    const searchText = search.toLowerCase();
    totalCustomers = totalCustomers.filter((cus) => {
      return (
        cus.name.toLowerCase().includes(searchText) ||
        String(cus.mobile).toLowerCase().includes(searchText) ||
        (cus.address || "").toLowerCase().includes(searchText) ||
        (cus.area.areaName || "").toLowerCase().includes(searchText)
      );
    });

    // Map to display rows

    let filtered = totalCustomers.map((item, index) => {
      const activeCount =
        item?.scheme?.filter((s) => s.status === "active").length || 0;

      return {
        id: index + 1,
        _id: item._id,
        name: item.name,
        mobile: String(item.mobile),
        address: item.address || "",
        payments: item.scheme?.[0]?.amount || 0,
        scheme: activeCount,
        status: activeCount > 0 ? "active" : "inactive",
        area: item.area.areaName,
        agent: item.agent?.name,
      };
    });

    // ------------------------------------
    // Sort Active → Inactive
    // ------------------------------------
    filtered = filtered.sort((a, b) => {
      if (a.status === "active" && b.status !== "active") return -1;
      if (a.status !== "active" && b.status === "active") return 1;
      return 0;
    });

    setFilteredData(filtered);
  }, [scheme, paymentFilter, search, userData]);

  const handleDeleteCustomer = async (id) => {
    if (!window.confirm("Do you want to delete this customer?")) return;

    const res = await axiosInstance.delete(`/customers/delete/${id}`);
    if (res.status === 200) {
      toast("User deleted successfully");
      setRefresh(true);
    } else {
      toast.error("Failed to delete user");
    }
  };
  const handleEditCustomer = (id) => {
    setEditId(id);
    setOpenAddCust(true);
  };
  const handleAddScheme = (id) => {
    setCustomerId(id);
    setOpenAddScheme(true);
  };
  const handleCustomerPayment = (id) => {
    setCustomerId(id);
    setOpenPaymentModal(true);
  };
  const handleviewCustomer = (id) => {
    setCustomerId(id);
    setOpenViewCustomer(true);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const openMenu = Boolean(anchorEl);

  const handleOpenMenu = (event, id) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(id);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedRowId(null);
  };

  return (
    <>
      <Typography
        variant="h5"
        color="#800001"
        sx={{ fontWeight: "400", textAlign: "center", mb: 2 }}
      >
        Customers
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 2,
          justifyContent: "space-between",
          padding: "10px",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            onClick={() => setOpenAddCust(true)}
            sx={{
              display: "flex",
              gap: 2,
              backgroundColor: "#800001",
              color: "white",
              padding: "10px",
            }}
          >
            <PersonAddIcon sx={{ fontSize: "24px" }} />
            <Typography
              variant="p"
              sx={{
                fontSize: "14px",
                fontFamily: "sans-serif",
                fontWeight: 500,
                display: { xs: "none", sm: "block" },
              }}
            >
              Add Customer
            </Typography>
          </Button>

          <Select
            placeholder="Schemes"
            indicator={<KeyboardArrowDown />}
            onChange={(e, newValue) => {
              setScheme(newValue);
            }}
            value={scheme}
            sx={{
              width: 120,
              [`& .${selectClasses.indicator}`]: {
                transition: "0.2s",
                [`&.${selectClasses.expanded}`]: {
                  transform: "rotate(-180deg)",
                },
              },
              color: "#800001",
            }}
            defaultValue={"All"}
          >
            <Option value={"All"}>All</Option>
            {userData?.schemes
              ?.filter((scheme) => scheme.status === "active")
              .map((scheme) => (
                <Option key={scheme._id} value={scheme._id}>
                  {scheme.schemeName}
                </Option>
              ))}
          </Select>
          <Select
            placeholder="Payments"
            indicator={<KeyboardArrowDown />}
            sx={{
              width: 120,
              [`& .${selectClasses.indicator}`]: {
                transition: "0.2s",
                [`&.${selectClasses.expanded}`]: {
                  transform: "rotate(-180deg)",
                },
              },
              color: "#800001",
            }}
            value={paymentFilter}
            onChange={(e, newValue) => {
              setPaymentFilter(newValue);
            }}
          >
            <Option value="All">All</Option>
            <Option value="paid">Paid</Option>
            <Option value="unpaid">Unpaid</Option>
            <Option value="active">Active</Option>
            <Option value="inactive">Inactive</Option>
          </Select>
        </Box>
        <TextField
          placeholder="Search"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            width: { xs: "100%", sm: "300px" },
            "& .MuiOutlinedInput-input": {
              padding: "10px",
              color: "#800001",
            },
            "& .MuiInputLabel-root": {
              color: "#800001",
            },
            "& .MuiInputLabel-shrink": {
              color: "#800001",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#800001", // Default border
              },
              "&:hover fieldset": {
                borderColor: "#cc0000", // On hover
              },
              "&.Mui-focused fieldset": {
                borderColor: "#800001", // On focus
              },
            },
          }}
        />
      </Box>
      <Box sx={{ width: { xs: "95vw", sm: "81vw" } }}>
        <Grids columns={columns} rows={filteredData} />
      </Box>
      <AddCustomer
        openCustomer={openAddCust}
        setOpenCustomer={setOpenAddCust}
        editId={editId}
        setEditId={setEditId}
      />
      <Payments
        openPaymentModal={openPaymentModal}
        setOpenPaymentModal={setOpenPaymentModal}
        customerId={customerId}
        setCustomerId={setCustomerId}
      />
      <ViewCustomer
        openViewCustomer={openViewCustomer}
        setOpenViewCustomer={setOpenViewCustomer}
        setCustomerId={setCustomerId}
        customerId={customerId}
      />
      <AddCustScheme
        openAddScheme={openAddScheme}
        setOpenAddScheme={setOpenAddScheme}
        customerId={customerId}
        setCustomerId={setCustomerId}
      />
      <Modal open={openUpdateModal} onClose={() => setOpenUpdateModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: 300, sm: 400 },
            bgcolor: "#FEDDDD",
            p: 3,
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <Typography sx={{ mb: 1, fontWeight: 600 }}>Add Update</Typography>

          <TextField
            multiline
            rows={4}
            fullWidth
            value={updateText}
            sx={{ bgcolor: "#fff" }}
            onChange={(e) => setUpdateText(e.target.value)}
            placeholder="Enter update notes..."
          />

          <Button
            sx={{
              mt: 2,
              backgroundColor: "#800001",
              color: "white",
              width: "100%",
              "&:hover": { backgroundColor: "#a00001" },
            }}
            onClick={async () => {
              await axiosInstance.post(`/customers/addupdates/${customerId}`, {
                updates: updateText,
                added_by: localStorage.getItem("userId"),
              });
              toast.success("Updates added");
              setRefresh(true);
              setOpenUpdateModal(false);
            }}
          >
            Save Updates
          </Button>
        </Box>
      </Modal>

      <Menu anchorEl={anchorEl} open={openMenu} onClose={handleCloseMenu}>
        <MenuItem
          sx={{
            color: "#800001",
            "&:hover": { backgroundColor: "#800001", color: "#fff" },
          }}
          onClick={() => {
            handleviewCustomer(selectedRowId);
            handleCloseMenu();
          }}
        >
          <VisibilityIcon fontSize="small" style={{ marginRight: 8 }} />
          View
        </MenuItem>

        {role === "admin" && (
          <MenuItem
            sx={{
              color: "#800001",
              "&:hover": { backgroundColor: "#800001", color: "#fff" },
            }}
            onClick={() => {
              handleEditCustomer(selectedRowId);
              handleCloseMenu();
            }}
          >
            <EditIcon fontSize="small" style={{ marginRight: 8 }} />
            Edit
          </MenuItem>
        )}

        <MenuItem
          sx={{
            color: "#800001",
            "&:hover": { backgroundColor: "#800001", color: "#fff" },
          }}
          onClick={() => {
            handleAddScheme(selectedRowId);
            handleCloseMenu();
          }}
        >
          <AddIcon fontSize="small" style={{ marginRight: 8 }} />
          Add Scheme
        </MenuItem>
        <MenuItem
          sx={{
            color: "#800001",
            "&:hover": { backgroundColor: "#800001", color: "#fff" },
          }}
          onClick={() => {
            handleAddUpdate(selectedRowId);
            handleCloseMenu();
          }}
        >
          <EditIcon fontSize="small" style={{ marginRight: 8 }} />
          Add Updates
        </MenuItem>

        {filteredData.find((row) => row._id === selectedRowId)?.status ===
          "active" && (
          <MenuItem
            sx={{
              color: "#800001",
              "&:hover": { backgroundColor: "#800001", color: "#fff" },
            }}
            onClick={() => {
              handleCustomerPayment(selectedRowId);
              handleCloseMenu();
            }}
          >
            <CurrencyRupeeIcon fontSize="small" style={{ marginRight: 8 }} />
            Payments
          </MenuItem>
        )}

        {role === "admin" && (
          <MenuItem
            sx={{
              color: "#800001",
              "&:hover": { backgroundColor: "#800001", color: "#fff" },
            }}
            onClick={() => {
              handleDeleteCustomer(selectedRowId);
              handleCloseMenu();
            }}
          >
            <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
            Delete
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default Customers;
